import { Component, OnInit } from '@angular/core';
import { PopulationQuery } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-predictor-layout-page',
  templateUrl: './predictor-layout-page.component.html',
  styleUrl: './predictor-layout-page.component.scss',
})
export class PredictorLayoutPageComponent implements OnInit {
  populations = Populations;
  isCorporate: boolean;
  constructor(private populationQuery: PopulationQuery) {}

  ngOnInit(): void {
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
  }
}
